import React from "react";
import { useSelector } from "react-redux";
import CompanySelectSide from "./CompanySelectSide";
import DashboardLinks from "./sections/DashboardLinks";
import ReportsMenu from "./sections/ReportsMenu";
import CombinedAdminMenu from "./sections/CombinedAdminMenu";
import ClientAdminMenu from "./sections/ClientAdminMenu";
import ToolsMenu from "./sections/ToolsMenu";
import ResourceLinks from "./sections/ResourceLinks";
import AccountMenu from "./sections/AccountMenu";
import PropTypes from "prop-types";

export default function LeftNavigation() {
    // Core selectors
    const pathname = useSelector(state => state.router.location.pathname);
    const enabledFeatures = useSelector(state => state.session.enabledFeatures);
    const companyId = useSelector(state => state.session.companyId);
    const isAuthenticated = useSelector(state => state.session.isAuthenticated);
    const pwExpired = useSelector(state => state.session.pwExpired);

    const hasCompanySelected = companyId != null && companyId > 0;
    const wayfarerMode = enabledFeatures.includes("integrate-wayfarer-header");

    return isAuthenticated ? (
        <div
            id="left-navigation"
            className={wayfarerMode === false ? "sidebar nav-collapsed" : "sidebar_wayfarer nav-collapsed_wayfarer"}
        >
            <ul className={wayfarerMode === false ? "sidebar-nav" : "sidebar_wayfarer-nav"}>
                {wayfarerMode === false && (
                    <li>
                        <img className="logo" src="/Images/Icons/logo-icon.png" />
                    </li>
                )}
                {wayfarerMode === true && <li>{!pwExpired && <CompanySelectSide isUpdateOnChange={true} />}</li>}
                {!pwExpired && (
                    <>
                        <DashboardLinks pathname={pathname} hasCompanySelected={hasCompanySelected} />
                        <ReportsMenu />
                        <CombinedAdminMenu />
                        <ClientAdminMenu />
                        <ToolsMenu />
                        <ResourceLinks />
                    </>
                )}
                <AccountMenu />
            </ul>
        </div>
    ) : null;
}

LeftNavigation.propTypes = {
    enabledFeatures: PropTypes.arrayOf(PropTypes.string),
    isAuthenticated: PropTypes.bool,
    userEmail: PropTypes.string,
    pwExpired: PropTypes.bool,
    companyId: PropTypes.number,
    pathname: PropTypes.string,
};
